module.exports = __webpack_public_path__ + "img/product-1-INTphone.9ba4d5ac.png";